module.exports = __webpack_public_path__ + "assets/img/arezzo.be465508.png";